import React, { useState, useEffect, useRef } from "react";
import MaterialTable from 'material-table'
import axios from 'axios';
import { ToastContainer,toast } from 'react-toastify';

import authHeader from "../../../../services/auth-header";
import { API } from "../../../../backend";
import { getTrans as t } from "../../../../Localization/translations";
import Helper from "../../../../Helper";

function AssetesQuote({ id }) {
    const [itemsAsset, setItemsAsset] = useState([]);

    const handelDefault1 = () => {
        let url = API + "contracts/asset-view/" + id + "/";
        axios.get(url, { headers: authHeader() })
            .then(response => {
                setItemsAsset(response.data.data)
            })
    }

    useEffect(() => {
        handelDefault1();
    }, [])
    const tableRef = useRef(null);

    useEffect(() => {
        if (tableRef.current) {
            const allRows = itemsAsset.map((item, index) => index);
            tableRef.current.onAllSelected(true, allRows);
        }
    }, [itemsAsset]);
    return (
        <>
            <div className="panel-content pt-5" style={{ paddingLeft: "10px" }}>
                <div className="row" id="assets">
                    <div className="col-md-12">
                        <div className="">
                            <div className="header pb-0 pt-2">
                                <div className="d-lg-flex">
                                    <div>
                                        <h5 className="mb-3 tc">{t('Assets in Termination')}
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div className="body">
                                <div className="table-responsive">
                                    <MaterialTable
                                        tableRef={tableRef}

                                        style={{
                                            backgroundColor: "var(--bs-table-bg)",
                                            borderBottomWidth: "1px",
                                            boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                                        }}
                                        columns={[
                                            {
                                                title: `${t("Asset No")}`,
                                                field: "asset_number",
                                                headerStyle: {
                                                    verticalAlign: "inherit",
                                                    fontWeight: "bold",
                                                    textAlign: "left"
                                                },
                                                cellStyle: {
                                                    textAlign: "left",
                                                    fontSize: 12
                                                },
                                                render: rowData => <>
                                                    <div className="d-xl-none tc d-md-none d-lg-none">{t("Asset No")}</div> <div className="hyperlink">{(rowData.asset_number)}</div></>
                                            },
                                            {
                                                title: `${t("Asset Description")}`,
                                                field: "asset_desc",
                                                render: rowData => <>
                                                    <div className="d-xl-none tc d-md-none d-lg-none">{t("Asset Description")}</div><div>{rowData.asset_desc ? rowData.asset_desc : "None"}</div></>,
                                                headerStyle: {
                                                    verticalAlign: "inherit",
                                                    fontWeight: "bold",
                                                    textAlign: "left"
                                                },
                                                cellStyle: {
                                                    textAlign: "left",
                                                    fontSize: 12
                                                }
                                            },
                                            {
                                                title: `${t("VIN Number")}`,
                                                field: "vin_number",
                                                render: rowData => <>
                                                    <div className="d-xl-none tc d-md-none d-lg-none">{t("VIN Number")}</div><div>{rowData.vin_number ? rowData.vin_number : "None"}</div></>,
                                                headerStyle: {
                                                    verticalAlign: "inherit",
                                                    fontWeight: "bold",
                                                    textAlign: "left"
                                                },
                                                cellStyle: {
                                                    textAlign: "left",
                                                    fontSize: 12
                                                }
                                            }, {
                                                title: `${t("Vehicle Cost")}`,
                                                field: "vehicle_cost",
                                                render: rowData => <>
                                                    <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                                    >{t("Vehicle Cost")}</div>
                                                    <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.vehicle_cost)}</div></>,
                                                headerStyle: {
                                                    verticalAlign: "inherit",
                                                    fontWeight: "bold",
                                                    textAlign: "right"
                                                },
                                                // cellStyle: {
                                                //     textAlign: "right",
                                                //     fontSize: 12
                                                // }
                                            },

                                            {
                                                title: `${t("Residual Value")}`,
                                                field: "residal_value",
                                                render: rowData => <>
                                                    <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                                    >{t("Residual Value")}</div><div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.residal_value)}</div></>,
                                                headerStyle: {
                                                    verticalAlign: "inherit",
                                                    fontWeight: "bold",
                                                    textAlign: "right"
                                                },
                                                // cellStyle: {
                                                //     textAlign: "right",
                                                //     fontSize: 12
                                                // }
                                            },
                                            {
                                                title: `${t("In Service Date")}`,
                                                field: "in_service_date",
                                                render: rowData => <>
                                                    <div className="d-xl-none tc d-md-none d-lg-none">{t("In Service Date")}</div><div>{rowData.in_service_date ? Helper.DateNormal(rowData.in_service_date) : "None"}</div></>,
                                                headerStyle: {
                                                    verticalAlign: "inherit",
                                                    fontWeight: "bold",
                                                    textAlign: "left"
                                                },
                                                cellStyle: {
                                                    textAlign: "left",
                                                    fontSize: 12
                                                }
                                            },
                                        ]}
                                        data={itemsAsset}
                                        options={{
                                            headerStyle: {
                                                backgroundColor: "white",
                                                color: "#245C7F",
                                                fontSize: 12,
                                            },

                                            headerSelection: false, // Disable column header selection

                                            rowStyle: (rowData, index) => {
                                                if (index % 2) {
                                                    return { backgroundColor: "#fff" }
                                                }
                                            },
                                            sorting: true,
                                            search: false,
                                            toolbar: false,
                                            paging: true,
                                            pageSize: 5,       // make initial page size
                                            emptyRowsWhenPaging: false,   // To avoid of having empty rows
                                            pageSizeOptions: [5, 15, 20, 50],
                                            paginationType: "stepped",
                                            showFirstLastPageButtons: false,
                                            actionsColumnIndex: -1,
                                            selection: true,
                                            selectionProps: {
                                                disabled: true
                                            },
                                            showSelectAllCheckbox: false,
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AssetesQuote;